export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m12 2 9 4.989v10.022L12 22l-9-4.989V6.989L12 2zm0 2.2614-5.9603 3.304L12 10.8692l5.9603-3.304L12 4.2613zM5 15.8583v-6.608l6 3.326v6.608l-6-3.326zm8 3.326 6-3.326v-6.608l-6 3.326v6.608z" } }];
export const iconName = 'cube-3d';
export const cube3d = { iconName, paths };
export default paths;
